import moment from 'moment';
import reseauxParametreInitializer from '@/services/patrimoine/reseauxParametreInitializer';
import fromTypeToMarkers from '@/services/catalogue/fromTypeToMarkers';
import customArraySort from '@/services/general/customArraySort';
import {
  RESEAU_FROM_VENTES_RESEAUX,
  FACES_FROM_VENTES_RESEAUX,
} from '@/configuration/carteConf';
import gestionErreur from '@/services/general/gestionErreur';
import filterLatLng from '@/services/general/gestionLatLng';
import { browseReseaux } from '../../api/reseaux';
import * as types from './reseauxTempo-mutation-type';
import * as allTypes from '../mutation-type';


function initialState() {
  return {
    reseaux: [],
    reseauxHorsSecteur: [],
    showReseauxHorsSecteur: false,
    markersReseauxHorsSecteur: [],
    markersFacesParReseauxHorsSecteur: [],
  };
}

const state = initialState();
const namespaced = true;

const mutations = {
  [allTypes.RESET_STATE]() {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
  [allTypes.RESET_NOT_PERSISTED](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
  [types.SET_RESEAUX](state, reseaux) {
    state.reseaux = reseaux;
  },
  [types.SET_RESEAUX_HORS_SECTEUR](state, reseauxHorsSecteur) {
    state.reseauxHorsSecteur = reseauxHorsSecteur;
  },
  [types.SET_SHOW_RESEAUX](state, showReseauxHorsSecteur) {
    state.showReseauxHorsSecteur = showReseauxHorsSecteur;
  },
  [types.SET_MARKER_RESEAUX](state, markersReseauxHorsSecteur) {
    state.markersReseauxHorsSecteur = markersReseauxHorsSecteur;
  },
  [types.SET_MARKER_FACES_DE_RESEAUX](state, markersFacesParReseauxHorsSecteur) {
    state.markersFacesParReseauxHorsSecteur = markersFacesParReseauxHorsSecteur;
  },
  [types.TRIE_RESEAUX](state) {
    state.reseaux.sort(customArraySort(['ville', 'libelle', 'code']));
  },
};


const actions = {
  rechercheReseauxHorsSecteur: async ({ rootGetters, getters, commit }) => {
    try {
      const dateDeVisualisation = moment(rootGetters['venteReseauxTempo/dateDeVisualisation']).format('YYYYMMDD');
      const azimut = rootGetters['user/afficherAzimut'];
      commit(types.SET_SHOW_RESEAUX, false);
      const response = await browseReseaux(dateDeVisualisation, rootGetters['venteReseauxTempo/avecConfreres'],
        [], false, true);
      response.data = reseauxParametreInitializer(response.data);
      commit(types.SET_RESEAUX, response.data);
      commit(types.TRIE_RESEAUX, getters.reseaux);
      const reseauxUserIds = rootGetters['venteReseauxTempo/reseauxWithFilter'].map(r => r.num);
      commit(types.SET_RESEAUX_HORS_SECTEUR, getters.reseaux.filter(r => !reseauxUserIds
        .includes(r.num)));
      commit(types.SET_MARKER_RESEAUX,
        fromTypeToMarkers(RESEAU_FROM_VENTES_RESEAUX, getters.reseauxHorsSecteur, azimut));
      commit(types.SET_SHOW_RESEAUX, true);
    } catch (e) {
      gestionErreur('Erreur lors du chargement des réseaux tempos hors secteur', e);
    }
  },
  updateMarkerReseau: ({ getters, rootGetters, commit, dispatch }) => {
    const azimut = rootGetters['user/afficherAzimut'];
    commit(types.SET_MARKER_RESEAUX,
      fromTypeToMarkers(RESEAU_FROM_VENTES_RESEAUX, getters.reseauxHorsSecteur, azimut));
    dispatch('fromFacesReseauxToMarkers', { dispo: false });
  },
  fromFacesReseauxToMarkers: ({ getters, rootGetters, commit }, payload) => {
    const allFaces = [];
    const azimut = rootGetters['user/afficherAzimut'];
    getters.reseauxHorsSecteur.forEach((reseau) => {
      const resultFilter = filterLatLng(reseau.listeFaces);
      const faces = resultFilter.goodList;
      faces.forEach((face) => {
        face.selected = reseau.selected;
        if (reseau.couleur) {
          face.color = reseau.couleur;
        }
        face.libelleReseau = reseau.libelle;
        if (payload.dispo) {
          if (face.dispo === 3) allFaces.push(face);
        } else {
          allFaces.push(face);
        }
      });
    });
    commit(types.SET_MARKER_FACES_DE_RESEAUX, fromTypeToMarkers(FACES_FROM_VENTES_RESEAUX,
      allFaces, azimut));
  },
};

const getters = {
  reseaux: (state) => {
    return state.reseaux;
  },
  reseauxHorsSecteur: (state) => {
    return state.reseauxHorsSecteur;
  },
  markersReseauxHorsSecteur: (state) => {
    return state.markersReseauxHorsSecteur;
  },
  markersFacesParReseauxHorsSecteur: (state) => {
    return state.markersFacesParReseauxHorsSecteur;
  },
  showReseauxHorsSecteur: (state) => {
    return state.showReseauxHorsSecteur;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/creationOpportunite/reseauxTempo.js